var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLiLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1312.35 338.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1{fill:url(#linear-gradient);}.cls-1,.cls-2,.cls-3,.cls-4,.cls-5{stroke-width:0px;}.cls-2{fill:url(#linear-gradient-4);}.cls-3{fill:url(#linear-gradient-2);}.cls-4{fill:url(#linear-gradient-3);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 215.94,
    y1: 108.17,
    x2: 178.01,
    y2: 181.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#fff450"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#fff561"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#fff78b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#fff9ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#fffbcc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#fffde2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#fffef2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#fffefc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 143.61,
    y1: 34.95,
    x2: 194.37,
    y2: 117.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#4fe7af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#5ae7a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#7aea97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#aded7b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#f3f356"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#fff450"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 143.74,
    y1: 81.04,
    x2: 31.24,
    y2: 123.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#11c4d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4fe7af"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 138.05,
    y1: 252.6,
    x2: 96.75,
    y2: 152.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#cbdfff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#95bfff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#68a4ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#428dff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#257cff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#106fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#0468ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#06f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#016efa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#0687ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#0daedd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#11c4d4"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M231.27,125.61l-41.14-13.51s16.78,28.55-26.42,49.66c0,0,24.53,1,41.04-3.16-11.53-4.05,1.54-22.01,26.52-32.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M155.8,42.13s-3.7,33.08-24.19,49.47c8.94-2.48,43.6-6.85,58.52,20.5l19.94-45.49s-38.39,10.5-54.27-24.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M131.61,91.6c-28.58-11.15-46.24-33.54-46.24-33.54-.05,48.93-45.93,55.17-45.93,55.17l56.64,30.87c-7.64-22.88,6.49-45.51,35.53-52.5Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 121.97,
    cy: 56.24,
    r: 36.65
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 217.8,
    cy: 97.14,
    r: 31.49
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M96.02,143.72l-38.35,67.22s53.02-13.34,71.48,36.48l34.57-85.66s-50.92,20.42-67.7-18.04Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 49.72,
    cy: 161.87,
    r: 49.71
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 188.97,
    cy: 221.76,
    r: 65.09
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M770.07,40.4c-4.85,0-9.36-1.4-13.21-3.78v98.28h26.41V36.63c-3.84,2.38-8.36,3.78-13.21,3.78Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 770.07,
    cy: 15.26,
    r: 15.26
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M425.64,134.9h-79.99V4.38h27.32v107.91h52.67v22.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M526.37,105.23c-2.89,18.99-20.26,31.75-44.23,31.75-29.85,0-47.76-19.09-47.76-50.11s18.09-51.01,46.76-51.01,46.04,19.09,46.04,48.57v8.05h-66.84v1.63c0,13.84,8.77,23.34,22.25,23.34,9.68,0,17.09-4.79,19.54-12.21h24.24ZM460.61,76.29h41.16c-.54-12.39-8.59-20.89-20.35-20.89s-19.9,8.77-20.8,20.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M541.89,37.94h25.51v17.28h.54c5.16-12.03,15.38-19.09,30.3-19.09,21.53,0,33.65,13.57,33.65,36.27v62.5h-26.41v-56.98c0-12.66-5.97-19.9-17.82-19.9s-19.36,8.68-19.36,21.26v55.63h-26.41V37.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M644.72,86.24c0-30.75,15.38-49.84,39.71-49.84,14.02,0,24.87,7.42,29.58,18.18h.54V4.38h26.41v130.52h-26.05v-16.64h-.45c-4.7,10.67-15.92,18.18-30.21,18.18-24.24,0-39.53-19.18-39.53-50.2ZM671.77,86.42c0,17.82,8.14,28.76,21.44,28.76s21.53-11.04,21.53-28.76-8.41-28.85-21.53-28.85-21.44,11.13-21.44,28.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M799.18,37.94h25.51v17.28h.54c5.16-12.03,15.38-19.09,30.3-19.09,21.53,0,33.65,13.57,33.65,36.27v62.5h-26.41v-56.98c0-12.66-5.97-19.9-17.82-19.9s-19.36,8.68-19.36,21.26v55.63h-26.41V37.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M904.99,141.78h25.87c2.08,6.69,9.68,11.22,19.72,11.22,13.66,0,21.26-7.51,21.26-18.72v-17h-.54c-4.52,10.31-15.92,17.37-29.94,17.37-23.7,0-39.35-18.27-39.35-48.57s15.2-49.66,39.8-49.66c13.93,0,24.87,7.33,29.94,18.45h.45v-16.91h26.05v95.61c0,23.06-19.36,37.9-48.39,37.9-25.51,0-42.78-12.39-44.86-29.67ZM971.92,86.24c0-17.46-8.41-28.67-21.62-28.67s-21.26,11.04-21.26,28.67,8.14,28.04,21.26,28.04,21.62-10.49,21.62-28.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M771.07,207.56c-4.85,0-9.36-1.4-13.21-3.78v98.28h26.41v-98.28c-3.84,2.38-8.36,3.78-13.21,3.78Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 771.07,
    cy: 182.41,
    r: 15.26
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M345.66,302.06v-130.52h27.32v130.52h-27.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M393.41,205.1h25.51v17.28h.54c5.16-12.03,15.38-19.09,30.3-19.09,21.53,0,33.65,13.57,33.65,36.27v62.5h-26.41v-56.98c0-12.66-5.97-19.9-17.82-19.9s-19.36,8.68-19.36,21.26v55.63h-26.41v-96.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M534.74,182.76v22.34h17.91v19.9h-17.91v46.4c0,7.42,3.62,10.95,11.4,10.95,2.35,0,4.79-.18,6.42-.45v19.45c-2.71.63-7.24,1.09-12.57,1.09-22.79,0-31.66-7.6-31.66-26.5v-50.92h-13.66v-19.9h13.66v-22.34h26.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M654.72,272.39c-2.89,18.99-20.26,31.75-44.23,31.75-29.85,0-47.76-19.08-47.76-50.11s18.09-51.01,46.76-51.01,46.04,19.09,46.04,48.57v8.05h-66.84v1.63c0,13.84,8.77,23.34,22.25,23.34,9.68,0,17.09-4.79,19.54-12.21h24.24ZM588.96,243.45h41.16c-.54-12.39-8.59-20.89-20.35-20.89s-19.9,8.77-20.8,20.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M671.24,171.54h26.41v130.52h-26.41v-130.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M714.55,171.54h26.41v130.52h-26.41v-130.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M800.1,308.94h25.87c2.08,6.69,9.68,11.22,19.72,11.22,13.66,0,21.26-7.51,21.26-18.72v-17.01h-.54c-4.52,10.31-15.92,17.37-29.94,17.37-23.7,0-39.35-18.27-39.35-48.57s15.2-49.66,39.8-49.66c13.93,0,24.87,7.33,29.94,18.45h.45v-16.91h26.05v95.61c0,23.06-19.36,37.9-48.39,37.9-25.51,0-42.78-12.39-44.86-29.67ZM867.03,253.4c0-17.46-8.41-28.67-21.62-28.67s-21.26,11.04-21.26,28.67,8.14,28.04,21.26,28.04,21.62-10.49,21.62-28.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M998.18,272.39c-2.89,18.99-20.26,31.75-44.23,31.75-29.85,0-47.76-19.08-47.76-50.11s18.09-51.01,46.76-51.01,46.04,19.09,46.04,48.57v8.05h-66.84v1.63c0,13.84,8.77,23.34,22.25,23.34,9.68,0,17.09-4.79,19.54-12.21h24.24ZM932.43,243.45h41.16c-.54-12.39-8.59-20.89-20.35-20.89s-19.9,8.77-20.8,20.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1013.7,205.1h25.51v17.28h.54c5.16-12.03,15.38-19.09,30.3-19.09,21.53,0,33.65,13.57,33.65,36.27v62.5h-26.41v-56.98c0-12.66-5.97-19.9-17.82-19.9s-19.36,8.68-19.36,21.26v55.63h-26.41v-96.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1183.65,241.19c-1.54-10.22-8.32-17.46-19.18-17.46-13.02,0-21.17,11.04-21.17,29.76s8.14,29.94,21.26,29.94c10.58,0,17.46-6.33,19.09-16.91h24.6c-1.36,22.88-18.45,37.63-43.96,37.63-29.22,0-47.76-18.99-47.76-50.65s18.54-50.47,47.58-50.47c26.23,0,42.87,16.19,44.05,38.17h-24.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1311.53,272.39c-2.89,18.99-20.26,31.75-44.23,31.75-29.85,0-47.76-19.08-47.76-50.11s18.09-51.01,46.76-51.01,46.04,19.09,46.04,48.57v8.05h-66.84v1.63c0,13.84,8.77,23.34,22.25,23.34,9.68,0,17.09-4.79,19.54-12.21h24.24ZM1245.77,243.45h41.16c-.54-12.39-8.59-20.89-20.35-20.89s-19.9,8.77-20.8,20.89Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiLogo);
export default __webpack_public_path__ + "static/media/LI_Logo.2950ee8de45daa372076fc212a6dffbb.svg";
export { ForwardRef as ReactComponent };